import axiosClient from "api/axios_client.js";

const apiLoginSecurity = {
  // Login & security page data
  getLoginSecurity: () => axiosClient.get(`/user/login-security-get`),

  // Revoke a single active session
  revokeSession: (session_id) =>
    axiosClient.post(`/user/revoke-session`, { session_id }),

  // Sign out all other sessions (optionally keep current alive)
  revokeOtherSessions: (current_session_id) =>
    axiosClient.post(`/user/revoke-other-sessions`, { current_session_id }),
};

export default apiLoginSecurity;
